<div style="display:show" id="divdata">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'">{{'addDesig' | translate}}</h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'"> {{'editDesig' | translate}}</h5>
        <h5 class="medium m-0" *ngIf="type == 'DELETE'"> {{'deleteDesig' | translate}}</h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="backFromDesignation" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="desCode" placeholder="{{'code' | translate}}"
                   [(ngModel)]="desgdata.code"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'name' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" name="desName" placeholder="{{'name' | translate}}"
                   [(ngModel)]="desgdata.name"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'nameLocale' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" name="desNameLoc" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="desgdata.nameLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'description' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" name="desDesc" placeholder="{{'description' | translate}}"
                   [(ngModel)]="desgdata.description"
                   [readonly]="type == 'DELETE'" maxlength="500">
            <span class="info-text">({{'maxFiveHundred' | translate}})</span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <div class="form-group">
            <label> {{'descriptionLocale' | translate}}
                <!-- <span class="text-danger medium">*</span> -->
            </label>
            <input type="text" class="form-control" name="desDescLoc" placeholder="{{'descriptionLocale' | translate}}"
                   [(ngModel)]="desgdata.descriptionLocale"
                   [readonly]="type == 'DELETE'" maxlength="250">
            <span class="info-text">({{'maxTwoFifty' | translate}})</span>
        </div>
    </div>

    <div class="col-lg-8 col-md-3 ">
        <div class="form-group">
            <label> {{'level' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="number" class="form-control" name="desLevel" placeholder="{{'level' | translate}}"
                   [(ngModel)]="desgdata.level" min="1"
                   [readonly]="type == 'DELETE'"
                   onkeypress="return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"
                   max="100">
        </div>
    </div>
    <div class="col-lg-8 col-md-3" *ngIf="type == 'DELETE' && empPresent">
        <div class="form-group">
            <label for="designation">{{'altDesig' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="designationModel" name="designationModel"
                   [source]="designationObservableSource.bind(this)"
                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                   display-property-name="displayName"
                   placeholder="Type and choose the designation" class="form-control"
                   (valueChanged)="gotNewValue($event)"
                   max-num-list=5 [value-formatter]="nameValueFormatter" blank-option-text="Select"
                   [accept-user-input]=false
                   [no-match-found-text]="warning">
            <span class="info-text"> {{'selectDesig' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-8 col-md-3">
        <button class="btn btn-primary float-left mt-4" name="desAdd" *ngIf="type == 'ADD'" (click)=this.saveDesgData()>
            {{'add' |
            translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="desEdit" *ngIf="type == 'EDIT'"
                (click)=this.saveDesgData()>
            {{'updateChanges' | translate}}
        </button>
        <button class="btn btn-primary float-left mt-4" name="desDelete" *ngIf="type == 'DELETE'"
                (click)=this.deleteDesgData()>{{'delete' |
            translate}}
        </button>
        <button class="btn btn-secondary float-left mt-4 ml-1" name="desCancel" (click)="goToBackPage()"> {{'cancel' |
            translate}}
        </button>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/addDesignation.html